var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var DataSource_1;
/* eslint-disable import/no-duplicates */
import '@symon-ai/wisepipe-common'; // force import for JsonSchemaV2
import './column'; // force import for JsonSchemaV2
import * as path from 'path';
import { Utils, S3File } from '@symon-ai/wisepipe-common';
import { DateConverter, JSON, JsonConverter, JsonSchemaV2 } from '@symon-ai/wisepipe-serialize';
import { ImportConfigType } from './importConfigs/importConfig';
import { RestBasedImportTypes } from './importConfigs/restImportConfig';
import { DataCategory } from './importTask';
import { dataSourceSchemaValidation } from '../validations.generated';
export const UNIT_TEST_DATA_ROW_LIMIT = 100;
export const dataSourceSchema = {
    $id: 'urn:wisepipe-common-data:DataSource',
    type: 'object',
    properties: {
        dataSourceID: { type: 'string', uid: 9 },
        originID: { type: 'string', uid: 9 },
        name: { type: 'string', minLength: 1 },
        sourceFileName: { type: 'string' },
        importType: {
            type: 'string',
            enum: Object.values(ImportConfigType)
        },
        csvLocation: { $ref: 'urn:wisepipe-common:S3File' },
        csvPartLocations: {
            type: 'array',
            items: { $ref: 'urn:wisepipe-common:S3File' },
            uniqueItems: true
        },
        parquetLocation: { $ref: 'urn:wisepipe-common:S3File' },
        sampleLocation: { $ref: 'urn:wisepipe-common:S3File' },
        randomSampleLocation: { $ref: 'urn:wisepipe-common:S3File' },
        malformedLocation: { $ref: 'urn:wisepipe-common:S3File' },
        sparkSchemaLocation: { $ref: 'urn:wisepipe-common:S3File' },
        metadataLocation: { $ref: 'urn:wisepipe-common:S3File' },
        rootLocation: { $ref: 'urn:wisepipe-common:S3File' },
        rowcountLocation: { $ref: 'urn:wisepipe-common:S3File' },
        lastUpdated: { type: 'string', format: 'date-time' },
        columns: {
            type: 'array',
            items: { $ref: 'urn:wisepipe-common-data:Column' },
            minItems: 1,
            uniqueItems: true
        },
        extractDelimiter: { type: 'string', minLength: 0, maxLength: 1 },
        extractQuoteChar: { type: 'string', minLength: 1, maxLength: 1 },
        obsolete: { type: 'boolean' },
        subType: { type: 'string', enum: RestBasedImportTypes },
        dataCategory: { type: 'string', enum: Object.values(DataCategory) }
    },
    required: [
        'dataSourceID',
        'originID',
        'name',
        'importType',
        'lastUpdated',
        'csvLocation',
        'parquetLocation',
        'sampleLocation',
        'malformedLocation',
        'sparkSchemaLocation',
        'metadataLocation'
    ]
};
let DataSource = DataSource_1 = class DataSource {
    constructor(dataSourceID, originID, name, importType, lastUpdated, s3Bucket, s3Folder, columns, extractDelimiter, extractQuoteChar, subType, // for storing REST based placeholder import type
    dataCategory, sourceFileName) {
        this.dataSourceID = dataSourceID;
        this.originID = originID;
        this.name = name;
        this.importType = importType;
        this.lastUpdated = lastUpdated;
        this.obsolete = false;
        // Generate S3 locations for the datasource's files
        if (this.importType === ImportConfigType.Global) {
            this.rootLocation = new S3File(s3Bucket, s3Folder);
            this.csvLocation = new S3File(s3Bucket, path.join(s3Folder, 'none'));
            this.parquetLocation = new S3File(s3Bucket, path.join(s3Folder, 'parquet'));
            this.sampleLocation = new S3File(s3Bucket, path.join(s3Folder, 'sample'));
            this.randomSampleLocation = new S3File(s3Bucket, path.join(s3Folder, 'randomSample'));
            this.malformedLocation = new S3File(s3Bucket, path.join(s3Folder, 'none'));
            this.sparkSchemaLocation = new S3File(s3Bucket, path.join(s3Folder, 'sparkSchema.json'));
            this.rowcountLocation = new S3File(s3Bucket, path.join(s3Folder, 'rowcount'));
            this.metadataLocation = new S3File(s3Bucket, path.join(s3Folder, 'none'));
        }
        else if (this.importType === ImportConfigType.Symon) {
            this.rootLocation = new S3File(s3Bucket, path.join(s3Folder));
            this.csvLocation = new S3File(s3Bucket, path.join(s3Folder, 'none'));
            this.parquetLocation = new S3File(s3Bucket, path.join(s3Folder, 'parquet'));
            this.sampleLocation = new S3File(s3Bucket, path.join(s3Folder, 'sample'));
            this.randomSampleLocation = new S3File(s3Bucket, path.join(s3Folder, 'randomSample'));
            this.malformedLocation = new S3File(s3Bucket, path.join(s3Folder, 'none'));
            this.sparkSchemaLocation = new S3File(s3Bucket, path.join(s3Folder, 'sparkSchema.json'));
            this.rowcountLocation = new S3File(s3Bucket, path.join(s3Folder, 'rowcount'));
            this.metadataLocation = new S3File(s3Bucket, path.join(s3Folder, 'metadata'));
        }
        else {
            this.rootLocation = new S3File(s3Bucket, path.join(s3Folder, dataSourceID));
            const csvKey = path.join(s3Folder, dataSourceID, 'original_csv', name.endsWith('.csv') ? name : `${name}.csv`);
            this.csvLocation = new S3File(s3Bucket, csvKey);
            this.parquetLocation = new S3File(s3Bucket, path.join(s3Folder, dataSourceID, 'parquet'));
            this.sampleLocation = new S3File(s3Bucket, path.join(s3Folder, dataSourceID, 'sample'));
            this.randomSampleLocation = new S3File(s3Bucket, path.join(s3Folder, dataSourceID, 'randomSample'));
            this.malformedLocation = new S3File(s3Bucket, path.join(s3Folder, dataSourceID, 'malformed'));
            this.sparkSchemaLocation = new S3File(s3Bucket, path.join(s3Folder, dataSourceID, 'sparkSchema.json'));
            this.rowcountLocation = new S3File(s3Bucket, path.join(s3Folder, dataSourceID, 'rowcount'));
            this.metadataLocation = new S3File(s3Bucket, path.join(s3Folder, dataSourceID, 'metadata'));
        }
        this.columns = columns;
        this.extractDelimiter = extractDelimiter;
        this.extractQuoteChar = extractQuoteChar;
        //REST based placeholder imports will have importType = Rest, subType = placeholder import type
        if (subType && this.importType === ImportConfigType.Rest)
            this.subType = subType;
        if (dataCategory !== undefined)
            this.dataCategory = dataCategory;
        this.sourceFileName = sourceFileName;
        JSON.validate(this, DataSource_1);
    }
    // Returns the dataSourceID as a Buffer
    get bufferID() {
        return DataSource_1.bufferID(this.dataSourceID);
    }
    get origParquetLocation() {
        return this.getLocation('original_parquet');
    }
    get csvDialectLocation() {
        return this.getLocation('csv_dialect.json');
    }
    // this file is only available for imports that go through target-s3-csv
    get rowCountLocation() {
        if (this.rowcountLocation)
            return this.rowcountLocation;
        if (this.rootLocation) {
            return new S3File(this.rootLocation.bucket, path.join(this.rootLocation.key, 'rowcount'));
        }
        return new S3File(this.sampleLocation.bucket, this.sampleLocation.key.replace('/sample', '/rowcount'));
    }
    get rootDSLocation() {
        if (this.rootLocation) {
            return this.rootLocation;
        }
        return new S3File(this.sampleLocation.bucket, this.sampleLocation.key.replace('/sample', ''));
    }
    get totalRowCountLocation() {
        const rowCountLoc = this.rowCountLocation;
        const rowCountKey = rowCountLoc.key.replace(`${this.dataSourceID}/rowcount`, 'totalrowcount');
        return new S3File(rowCountLoc.bucket, rowCountKey);
    }
    getLocation(filename) {
        if (this.rootLocation) {
            return new S3File(this.rootLocation.bucket, path.join(this.rootLocation.key, filename));
        }
        return new S3File(this.metadataLocation.bucket, path.join(path.dirname(this.metadataLocation.key), filename));
    }
    static generateDataSourceID() {
        return Utils.newID();
    }
    static dataSourceID(bufferID) {
        return Utils.base64BufferToString(bufferID);
    }
    static bufferID(base64DataSourceID) {
        return Utils.base64StringToBuffer(base64DataSourceID);
    }
    static tableName(orgID, dataSourceID) {
        return `${orgID}/${dataSourceID}`;
    }
    static unitTestDataTableName(orgID, dataSourceID) {
        return `${orgID}/unitTests/${dataSourceID}`;
    }
    static malformedTableName(orgID, dataSourceID) {
        return `${orgID}/${dataSourceID}/malformed`;
    }
    static unitTestDataMalformedTableName(orgID, dataSourceID) {
        return `${orgID}/unitTests/${dataSourceID}/malformed`;
    }
};
__decorate([
    JsonConverter(new DateConverter('date-time'))
], DataSource.prototype, "lastUpdated", void 0);
DataSource = DataSource_1 = __decorate([
    JsonSchemaV2(dataSourceSchema, dataSourceSchemaValidation)
], DataSource);
export { DataSource };
//# sourceMappingURL=dataSource.js.map